import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=37734ec2&scoped=true"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&id=37734ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37734ec2",
  null
  
)

export default component.exports